<template>
    <div class="col mb-3">
        <div class="card h-100 day-of-tasks" v-bind:class="{today: isToday, selected: jumpedToDate}">
            <div class="card-header">
                <h5 class="card-title day-of-tasks__header--left">
                    <span class="day-of-tasks__day">{{dayofmonth}}</span>
                    <span class="day-of-tasks__weekday">{{weekday}}</span>
                </h5>
                <h5 class="card-title day-of-tasks__header--right text-right">
                    <span class="day-of-tasks__month">{{month}}</span>
                    <span class="day-of-tasks__year">{{year}}</span>
                </h5>
            </div>
            <div class="card-body">
                <template v-if="dayOfTasks.error">
                    <div class="col">
                        <div class="infobar infobar-error">
                            There was an error loading tasks for this day.
                            <button v-on:click="reloadTasks" class="btn btn-secondary">Reload</button>
                        </div>
                    </div>
                </template>
                <template v-else>
    <!--                <div v-if="!hasTasks" class="text-center text-muted"> &#45;&#45; no tasks &#45;&#45; </div>-->
                    <ul class="list-group list-group-flush day-of-tasks__tasks"
                        v-bind:class="{'force-show-scrollbars' : forceScrollbar}">
                        <task v-for="task in tasksToShow" v-bind:task="task" v-bind:key="task.id"></task>
                    </ul>
                    <div class="text-center day-of-tasks__add-task">
                        <button v-on:click.stop="addTask()" class="btn btn-normal add-task-button">+ Add a Task</button>
                    </div>
                </template>
            </div>
        </div>
        <div v-if="showEditTask" v-on:click="hideEditTask">
            <EditTask v-bind:task="task" v-if="showEditTask" v-on:closePopup="hideEditTask()"></EditTask>
        </div>
    </div>
</template>

<script>
    import { store } from '../../store.js'
    import * as dayjs from 'dayjs'
    import isToday from 'dayjs/plugin/isToday'
    dayjs.extend(isToday);

    import EditTask from "../tasks/EditTask";
    import Task from "./Task"
    import { tasksMixin } from '../../mixins/TasksMixin'

    export default {
        name: 'DayOfTasks',
        components: {
            EditTask,
            Task
        },
        mixins: [ tasksMixin ],
        data: function() {
            return {
                task: null,
                showEditTask: false
            }
        },
        props: {
            dayOfTasks: Object,
            statesToShow: Array,
            jumpedToDate: Boolean
        },
        computed: {
            tasksToShow: function() {
                let tasks = [];
                for (let task of this.dayOfTasks.tasks) {
                    if (task.booking && task.booking.state === 'cancelled') {
                        continue;
                    }
                    for (let shownState of this.statesToShow) {
                        if (shownState.checked === true && (task.state === shownState.state ||
                            shownState.state === 'overdue' && task.overdue === true)) {
                            tasks.push(task);
                            break;
                        }
                    }
                }
                this.sortByStateAndScheduledDate(tasks);
                return tasks;
            },
            forceScrollbar: function() {
                if (store.forceScrollbars) {
                    const tasks = this.tasksToShow;
                    return tasks.length > 6;
                }
                return false;
            },
            weekday: function () {
                return dayjs(this.dayOfTasks.date).format("dddd");
            },
            dayofmonth: function () {
                return dayjs(this.dayOfTasks.date).format("D");
            },
            month: function () {
                return dayjs(this.dayOfTasks.date).format("MMMM");
            },
            year: function () {
                return dayjs(this.dayOfTasks.date).format("YYYY");
            },
            isToday: function () {
                return dayjs().format("YYYY-MM-DD") === this.dayOfTasks.date
            },
            hasTasks: function () {
                return this.dayOfTasks.tasks.length > 0
            },
            canAddTask: function () {
                return dayjs(this.dayOfTasks.date).isToday()
            }
        },
        methods: {
            addTask: function () {
                this.task = {
                    name: "",
                    dueDate: dayjs().toISOString()
                };
                this.showEditTask = true
            },
            hideEditTask: function () {
                this.showEditTask = false
            },
            reloadTasks: function() {
                this.$root.$emit('task-added', this.dayOfTasks.date);
            },
            taskRescheduled: function (dayBelongedTo, task) {
                if (!dayjs(dayjs(dayBelongedTo).startOf("day")).isSame(dayjs(task.scheduledDate).startOf("day"))) {
                    if (dayjs(this.dayOfTasks.date).isSame(dayjs(dayBelongedTo).startOf("day"))) {
                        for (let i = 0; i < this.dayOfTasks.tasks.length; i++) {
                            if (task.reference === this.dayOfTasks.tasks[i].reference) {
                                this.dayOfTasks.tasks.splice(i, 1);
                                break;
                            }
                        }
                    } else if (dayjs(this.dayOfTasks.date).isSame(dayjs(task.scheduledDate).startOf("day"))) {
                        this.dayOfTasks.tasks.push(task);
                        this.sortByScheduledDate(this.dayOfTasks.tasks);
                    }
                }
            }
        },
        mounted() {
            this.$root.$on('task-rescheduled', this.taskRescheduled);
            this.$root.$on('finished-editing-task', this.hideEditTask);
        },
        beforeDestroy() {
            this.$root.$off('task-rescheduled', this.taskRescheduled);
            this.$root.$off('finished-editing-task', this.hideEditTask);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/components/day_of_tasks";

    .day-of-tasks:hover {

        .add-task-button {
            background-color: $grey-light;
            border-color: $grey-light;
            color: $grey-medium;
        }
    }

    .day-of-tasks__add-task:hover {
        .add-task-button {
            background-color: $blue-light;
            border-color: $blue-light;
            color: $blue-dark;
        }
    }

</style>